import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom";
import { Input } from '../../components/all';
import useAutoescola from '../../hooks/useAutoescola';
import Loading from '../../components/loading';
import FormCadastro from '../../components/formCadastro';

export default function Register() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { autoescolas, getAutoescolas, loadingAutoescolas } = useAutoescola();
    const [searchName, setSearchName] = useState('');

    useEffect(() => {
        async function fetchAutoescolas() {
            await getAutoescolas();
        }

        if (id) return;
        fetchAutoescolas();
    }, [getAutoescolas, id]);

    const RenderAutoescolas = () => {
        if (loadingAutoescolas) return (<Loading />);
        const autoescolasFiltered = autoescolas.filter((autoescola) => autoescola.nome.toLowerCase().includes(searchName.toLowerCase()));
        if (autoescolasFiltered.length === 0) return <p className='p-4 text-neutral-500'>Nenhuma autoescola encontrada.</p>;
        return (
            <>
                {autoescolasFiltered.map((autoescola) => (
                    <div key={autoescola.autoescola_id} className='flex px-5 py-5 border rounded-md hover:bg-gray-100 cursor-pointer items-center justify-start gap-4' onClick={() => navigate(`/register/${autoescola.autoescola_id}`)}>
                        <div className='rounded-full h-[60px] w-[60px] bg-neutral-300 border flex'>
                        </div>
                        <div className='flex flex-col justify-start items-start'>
                            <h2>{autoescola.nome}</h2>
                            <p className='text-neutral-500 text-sm'>{autoescola.cidade}/{autoescola.uf}</p>
                            <p className='text-neutral-500 text-sm'>{autoescola.endereco}</p>
                        </div>

                    </div>
                ))}
            </>
        )
    }

    return (
        <div className='flex w-full max-w-[400px] justify-center items-start h-full'>
            {id ? (
                <FormCadastro autoescola_id={id} />
            ) :
                <div className='w-full h-full'>
                    <div className='p-4 flex flex-col items-start'>
                        <button className='flex gap-2 items-center mb-8' onClick={() => navigate('/')}>
                            <span className="material-icons" >
                                arrow_back
                            </span >
                            Voltar
                        </button>
                        <Input placeholder="Digite o nome da autoescola" value={searchName} onChange={(e) => setSearchName(e.target.value)} />
                    </div>
                    <RenderAutoescolas />
                </div>
            }
        </div>
    )
}
